/**
 * User: nir
 * Date: 05/09/2016
 * Time: 13:24
 */

if (window.jQuery) {
    // Share Icons //
    jQuery(function ($) {
        var panel = $('ul[data-action="update-share"]');

        if (!panel || !panel.length) return;

        var articleContent = $('section[data-type="article-content"]');
        var runCss = false;
        if (panel.length !== 0 && articleContent !== 0) {
            var wrapper = $('.article #content-wrap .share-icons');

            function runTest() {

                var d = $.Deferred();

                if (!shouldRunTest()) return d.resolve();


                var iconSelector = $('.disc-icon.social', wrapper);

                TCT.Testing.getTestData(920, null).then(function (data) {
                    TCT.debug('Test data:', data);

                    if (data && data.variant) { // for extra safety
                        var shareIconVariant = data.variant,
                            shareIconInstruction = data.instruction

                        if (iconSelector.length > 0 ) {

                            switch (shareIconVariant) {
                                case "TEST920_BOTTOM_ICONS" :
                                    runCss = true;
                                    break;
                                case "TEST920_CURRENT_STATE":
                                    console.log('current state');
                                    break;
                                default:
                                    console.log('no test here');
                                    break;
                            }

                            // track variant visible
                            TCT.Testing.reportVariantVisible(data);
                        }
                    }

                    d.resolve();
                }, d.resolve);


                return d.promise();
            }

            runTest().then(init);

            function init() {
                wrapper.show();
                var $window = $(window);
                var body = $('body');
                var clone = panel.clone();

                clone.addClass('fixed');

                $window.on('scroll resize', function () {
                    if ($('#branch-banner').length > 0 && $('#branch-banner').height() == 80){
                        $('.share-icons.fixed').addClass('smaller');
                    }
                    var top = panel.offset().top;
                    var vertical = (panel.css('flex-direction') === 'column');
                    var windowScrollTop = $window.scrollTop();
                    var articleTop = articleContent.offset().top;
                    var articleHeight = articleContent.height();
                    var panelHeight = panel.outerHeight();
                    var articleBottom = articleTop + articleHeight - panelHeight;
                    var left = panel.offset().left;
                    var offsetParent = articleContent.offsetParent();
                    var absTop = offsetParent.offset().top + articleContent.position().top + articleContent.height() - panelHeight;
                    clone.toggleClass('vertical', vertical);

                    // TCT.debug('windowScrollTop: %d, articleTop: %d, panelHeight: %d, articleBottom: %d', windowScrollTop, articleTop, panelHeight, articleBottom);
                    // TCT.debug('vertical:', vertical);
                    // TCT.debug('left:', left);

                    if (vertical) {

                        if (windowScrollTop >= top && windowScrollTop <= articleBottom) {
                            clone.removeAttr('style').toggleClass('absolute', false).css('left', left);
                            if (!clone.is('.shown')) {
                                clone.hide().toggleClass('shown', true).appendTo(body).show();
                                panel.toggleClass('transparent', true);
                            }
                        } else if (windowScrollTop > articleBottom) {
                            clone.toggleClass('absolute', true).css({
                                position: 'absolute',
                                top: absTop
                            });
                        } else {
                            clone.toggleClass('shown', false).hide().remove();
                            panel.toggleClass('transparent', false);
                        }
                    } else {
                        if (windowScrollTop >= top) {
                            clone.removeAttr('style').toggleClass('absolute', false).css('left', left);
                            if (!clone.is('.shown')) {
                                clone.hide().toggleClass('shown', true).appendTo(body).show();
                                panel.toggleClass('transparent', true);
                            }
                        } else {
                            clone.toggleClass('shown', false).hide().remove();
                            panel.toggleClass('transparent', false);
                        }

                        if(runCss == true){
                            $('ul.share-icons.fixed.shown').css({
                                'bottom': 0,
                                'top': 'auto',
                                'background':'#fff',
                                'width':'100%',
                                'left': 0,
                                'height': '55px',
                                'padding': 0,
                            });
                            $('.article-back-to-top').css('bottom', '57px');
                        }
                    }




                }).trigger('scroll');

            }
        }

        function shouldRunTest() {
            return false;
        }

        function checkAndAddStyle(selector, style) {
            if (selector.length > 0 && style !== null) {
                selector.css(style);
            }
        }
    });
    // END - Share Icons //
}
